export interface HostJoinWarningInput {
  isHost: boolean
  isGhost: boolean
  micEnabled: boolean
  /** deviceProbe MicAccess plus the prejoin's own 'checking' | 'idle' phases. */
  micStatus: string
  /** Peak level seen since the probe started. */
  micPeak: number
  /** The "we heard you" threshold — Prejoin's HEARD_PEAK. */
  heardPeak: number
}

export type HostJoinWarning = null | 'checking' | 'off' | 'fault' | 'unheard'

/** The teacher can always enter; this says when they need an honest warning. */
export function hostJoinWarning({
  isHost,
  isGhost,
  micEnabled,
  micStatus,
  micPeak,
  heardPeak,
}: HostJoinWarningInput): HostJoinWarning {
  if (isGhost || !isHost) return null
  if (micStatus === 'checking') return 'checking'
  if (!micEnabled) return 'off'
  if (micStatus !== 'ok') return 'fault'
  return micPeak > heardPeak ? null : 'unheard'
}
